export default __webpack_public_path__ + "1ef7bc7138910d66d9a2215cdaff24e8.png";